import React, { Component } from 'react';

// Import assets
import infoIcon from '../assets/images/info.png';

// Import components.
import PayixButton from '../containers/payix-button';

class LinkingLoanAccountNotice extends Component {
  /**
   * Render a component view.
   */
  render() { 
    return (
      <div>
        <div className="modal__header">
          <div className="modal__header-content--centered">
            <img src={ infoIcon } alt="" />
          </div>
        </div>

        <div className="modal__body">
          <div className="modal__body-content--pad35 text-center">
            <p className="modal-paragraph">
              A notice has been sent to your lender to assist with linking your account.
              <br />
              <span className="gothammedium-font">You will be notified once done.</span>
            </p>

            <div className="form-group">
              <PayixButton className="button--full" onClick={ this.props.onBackToHome }>
                BACK TO HOME
              </PayixButton>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
 
export default LinkingLoanAccountNotice;


// WEBPACK FOOTER //
// ./src/components/linking-loan-account-notice.js